import { Flash } from '@/types/flash';
import React, { createContext, useState } from 'react';

interface ContextType {
  flash?: Flash;
  setFlash?: (flash: Flash) => void;
}

export const FlashContext = createContext<ContextType>({});

interface Props {
  children: JSX.Element | JSX.Element[];
}

export const FlashProvider: React.FC<Props> = ({ children }) => {
  const [flash, setFlash] = useState<Flash>();

  return (
    <FlashContext.Provider
      value={{
        flash: flash,
        setFlash: (flash?: Flash) => setFlash(flash)
      }}
    >
      {children}
    </FlashContext.Provider>
  );
};
